<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><em class="italic"><a id="page_4">Song of Trusting the Heart</a></em></h1><a id="page_4">
<p class="subtitle">A C<span class="smallcaps">LASSIC</span> Z<span class="smallcaps">EN</span> P<span class="smallcaps">OEM</span> <span class="smallcaps">FOR</span> D<span class="smallcaps">AILY</span> M<span class="smallcaps">EDITATION</span></p>
<p class="author">T<span class="small">AMARACK</span> S<span class="small">ONG</span></p>
<p class="author1">A<span class="smallcaps">RT</span> <span class="smallcaps">BY</span> J<span class="smallcaps">AN</span> Z<span class="smallcaps">AREMBA</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?d64e6366